var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackspace = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.501,
    height: 19.249,
    viewBox: "0 0 27.501 19.249",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cancel",
    d: "M2.318,13.745l6.875-8.25A1.375,1.375,0,0,1,10.252,5H25.376A4.125,4.125,0,0,1,29.5,9.125v11a4.125,4.125,0,0,1-4.125,4.125H10.252a1.375,1.375,0,0,1-1.059-.495L2.318,15.5A1.375,1.375,0,0,1,2.318,13.745ZM10.9,21.5H25.376a1.375,1.375,0,0,0,1.375-1.375v-11A1.375,1.375,0,0,0,25.376,7.75H10.9L5.165,14.625Zm3.877-10.6a1.375,1.375,0,0,1,1.952,0L18.5,12.686,20.275,10.9a1.381,1.381,0,0,1,1.952,1.952L20.44,14.625,22.228,16.4a1.381,1.381,0,1,1-1.952,1.952L18.5,16.563l-1.774,1.787A1.381,1.381,0,1,1,14.775,16.4l1.787-1.774-1.787-1.774a1.375,1.375,0,0,1,0-1.952Z",
    transform: "translate(-2 -5)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackspace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/backspace.c80980fa092d64dd0fbc8894299162eb.svg";